/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import useDebounce from 'modules/common/components/UseDebounce';
import Covid19Content from './Covid19Content';

import * as c from '../constant'
import * as actions from '../action';

const form = {
  keyword: '',
  category: '',
  full_name: '',
  module_type: 'EHELP', 
};

function Covid19Container({
  match,
  history,
  getCovidVaccineRegList,
  covidVaccineRegList,
  covidVaccineRegListPager,
  isLoading_,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {
    getCovidVaccineRegList()

    return () => {
      setModal({ isOpen: false });
    };
  };

  const param = {
    module_type: 'EHELP',
    q: formData.keyword,
    sort_by: 'asc',
    full_name: filter.full_name,
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      full_name: e.value,
    });
    getCovidVaccineRegList({ ...filter, [key]: e.value })
  };


  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {      
      getCovidVaccineRegList({ module_type: 'EHELP', q: formData.keyword })
    } else {
      getCovidVaccineRegList({ module_type: 'EHELP' })
    }
  }, [debouncedSearchTerm]);

  const getExtName = (item) => 
    _.get(item, 'attributes.extension_name');

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName=""
            getData={getCovidVaccineRegList}
            setParams={param}
            setKeyword={handleOnChange}
            statusFilter={false}
            setStatusFilter={handleOnChangeSelect(_.get(formData, 'full_name'))}
            status={_.get(filter, 'full_name') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search List..."
            pathName={`${match.path}/:id?`}
            // listName="Transaction"
            label="Citizen List"
            // LEFT SECTION
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="registered-citizen-list">
                  {`${_.get(item, 'attributes.first_name')} ${
                    _.get(item, 'attributes.middle_name') || ''
                  } 
                  ${_.get(item, 'attributes.last_name')}  ${
                    getExtName(item) || ''
                  }`}
                </div>
                <h4 className="mt-1 mb-0 registered-citizen-list-numbers">
                  {' '}
                  {_.get(item, 'attributes.contact_number')}{' '}
                </h4>
              </div>  
            )}
            isLoading={isLoading_}
            selected={params.id}
            data={covidVaccineRegList}
            dataPager={covidVaccineRegListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            // RIGHT SECTION
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <Covid19Content 
                        UpdateData={UpdateData}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.id && covidVaccineRegList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(covidVaccineRegList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

Covid19Container.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getCovidVaccineRegList: PropTypes.instanceOf(Function).isRequired,
  covidVaccineRegList: PropTypes.instanceOf(Array).isRequired,
  covidVaccineRegListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading_: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  covidVaccineRegList: _.get(api, `${c.GET_REGISTRATION}.list`) || [],
  covidVaccineRegListPager: _.get(api, `${c.GET_REGISTRATION}.pager`) || [],
  isLoading_: api.loading.indexOf(c.GET_REGISTRATION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(Covid19Container);